document.addEventListener("DOMContentLoaded", () => {
  const computeEmptyBoxHeight = () => {
    // 计算空盒子高度
    const emptyBoxEl = document.querySelector(".product-comparison .empty-box");
    const targetWidth = document.querySelector(
      ".product-comparison .right-product-list li .product-box"
    );
    emptyBoxEl.style.height = `${targetWidth.offsetHeight}px`;

    // 计算li元素宽度
    const liEls = document.querySelectorAll(
      ".product-comparison-table:nth-child(4) .right-product-list>li"
    );
    const liTargetWidth = document.querySelector(
      ".product-comparison-table:nth-child(2) .right-product-list>li"
    ).offsetWidth;
    liEls.forEach((li) => {
      li.style.width = liTargetWidth + "px";
    });

    // 同步侧边标题的宽度
    if ($(window).width() < 1000) {
      $(".product-comparison-left-title").css("flex-basis", `max-content`);
      let tempMaxWidth = 0;
      $(".product-comparison-left-title").each(function () {
        if ($(this).width() > tempMaxWidth) {
          tempMaxWidth = $(this).width();
        }
      });
      $(".product-comparison-left-title").css(
        "flex-basis",
        `${
          tempMaxWidth +
          parseInt($(".product-comparison-left-title").css("padding-right"), 10)
        }px`
      );
    } else {
      $(".product-comparison-left-title").css("flex-basis", `20%`);
    }

    // 同步左右两边子元素的高度
    $(".product-comparison-table").each(function () {
      for (let i = 0; i < $(this).find(".left-title-item").length; i++) {
        // 找出最大高度
        let tempMaxHeight = 0;
        let length = $(this).find(".right-product-list>li").length;
        for (let k = 0; k < length; k++) {
          let height = $(this)
            .find(".right-product-list>li")
            .eq(k)
            .find(".property-item")
            .eq(i)
            .height();
          if (height > tempMaxHeight) {
            tempMaxHeight = height;
          }
        }
        $(this).find(".left-title-item").eq(i).height(tempMaxHeight);
        if ($(window).width() < 590) {
          $(this)
            .find(`.property-list .property-item:nth-child(${i + 1})`)
            .height(tempMaxHeight);
        }
      }
    });

    // 计算switch左边距
    if (document.querySelector(".material-switch")) {
      const targetPaddingLeft = window.getComputedStyle(
        document.querySelector(
          ".product-comparison-left-title .left-title-item"
        )
      ).paddingLeft;
      document.querySelector(".material-switch").style.paddingLeft =
        targetPaddingLeft;
    }
  };
  computeEmptyBoxHeight();
  $(window).on("resize", computeEmptyBoxHeight);

  // 获取 ul 元素
  const ulElements = document.querySelectorAll(
    ".product-comparison .right-product-list"
  );

  // 监听 scroll 事件
  ulElements.forEach((item) => {
    item.addEventListener("scroll", (event) => {
      ulElements.forEach((i) => {
        i.scrollLeft = item.scrollLeft;
      });
    });
  });

  // 监听material-switch点击
  $(".material-switch").click(function () {
    if ($(this).hasClass("close")) {
      $(this).removeClass("close").addClass("open");
      $(".product-comparison-table.material").slideToggle();
    } else {
      $(this).removeClass("open").addClass("close");
      $(".product-comparison-table.material").slideToggle();
    }
  });
});
